module.exports = __webpack_public_path__ + "img/sys_maintain4.4450fbfb.png";